import React from "react";

const projects = [
  {
    title: "Lysna Website",
    url: "https://lysna.com/",
    description: "Designed and developed a modern, responsive website for Lysna, focusing on clean UI and improved user experience.",
    category: "Web App"
   },
   {
     title: "Prote-Go Hygiene",
     url: "https://www.protegohygiene.com/",
     description: "Developed an informational platform and storefront with a focus on usability, performance, and accessibility.",
     category: "Website"
  },
  {
    title: "Ship My India",
    url: "https://shipmyindia.com/",
    description: "Designed and developed a responsive logistics and freight forwarding website with an intuitive user interface, optimized performance, and seamless user experience for global shipping services.",
    category: "Website"
  },
  {
    title: "Skillified",
    url: "ttps://skillified-2.myshopify.com/",
    description: "Customized and optimized a Shopify storefront to enhance user experience and improve performance.",
    category: "Shopify"
  },
  {
    title: "Nobe Yoga",
    url: "https://nobeyoga.com/",
    description: "Designed a calm and engaging UI/UX experience for a local yoga studio website.",
    category: "Website"
  },
  {
    title: "Compassionate Care",
    url: "https://www.compassionatecareinyourhome.com/",
    description: "Created an accessible and user-friendly website for home care services with a focus on clarity and trust.",
    category: "Website"
  },

];

const skills = ["React", "Figma", "HTML5", "CSS3", "JavaScript", "Tailwind CSS", "UI/UX Design"];

function App() {
  return (
    <div className="min-h-screen bg-slate-950 text-white font-sans selection:bg-purple-500 selection:text-white">
      {/* Dynamic Background */}
      <div className="fixed inset-0 z-0 overflow-hidden pointer-events-none">
        <div className="absolute top-[-10%] left-[-10%] w-[50vw] h-[50vw] rounded-full bg-purple-700/20 blur-[120px] mix-blend-screen" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[60vw] h-[60vw] rounded-full bg-blue-700/20 blur-[120px] mix-blend-screen" />
      </div>

      <div className="relative z-10">
        {/* Navigation */}
        <nav className="fixed w-full flex flex-col md:flex-row items-center justify-between px-8 py-5 backdrop-blur-md bg-slate-950/60 border-b border-white/5 z-50">
          <div className="text-2xl font-bold tracking-tighter bg-gradient-to-r from-blue-400 to-purple-500 bg-clip-text text-transparent">
            Anisha Selote
          </div>
          <div className="hidden md:flex space-x-10 text-sm font-medium text-slate-300 mt-4 md:mt-0">
            <a href="#about" className="hover:text-white transition-colors duration-200">About</a>
            <a href="#projects" className="hover:text-white transition-colors duration-200">Projects</a>
            <a href="#contact" className="hover:text-white transition-colors duration-200">Contact</a>
          </div>
        </nav>

        {/* HERO SECTION */}
        <section className="flex flex-col justify-center items-center h-screen px-6 text-center pt-20">
          <div className="inline-block px-4 py-1.5 mb-8 rounded-full bg-slate-800/50 border border-slate-700 backdrop-blur-sm text-sm font-medium text-slate-300">
            ✨ Available for freelance & full-time opportunities
          </div>
          <h1 className="text-5xl md:text-8xl font-black tracking-tight mb-6">
            Hi, I'm <span className="bg-gradient-to-r from-purple-400 via-pink-400 to-blue-500 bg-clip-text text-transparent drop-shadow-sm">Anisha</span>
          </h1>
          <p className="text-lg md:text-2xl text-slate-400 max-w-2xl font-light mb-12 leading-relaxed">
            I'm always open to discussing UI/UX design, frontend development projects, or collaboration opportunities.
          </p>
          <div className="flex flex-col sm:flex-row items-center gap-4">
            <a
              href="#projects"
              className="group relative px-8 py-4 bg-white text-slate-950 font-semibold rounded-full overflow-hidden transition-all duration-300 hover:scale-105 hover:shadow-[0_0_40px_rgba(255,255,255,0.3)]"
            >
              <span className="relative z-10 flex items-center gap-2">
                Explore My Work
                <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                </svg>
              </span>
            </a>
            <a
              href="/resume.html"
              target="_blank"
              rel="noopener noreferrer"
              className="group relative px-8 py-4 bg-slate-800/50 text-white font-semibold rounded-full border border-slate-700 backdrop-blur-sm overflow-hidden transition-all duration-300 hover:scale-105 hover:bg-slate-800 hover:border-slate-500 hover:shadow-[0_0_30px_rgba(255,255,255,0.1)]"
            >
              <span className="relative z-10 flex items-center gap-2">
                Open Resume
                <svg className="w-5 h-5 group-hover:translate-y-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                </svg>
              </span>
            </a>
          </div>
        </section>

        {/* ABOUT & SKILLS SECTION */}
        <section id="about" className="py-24 px-6 max-w-5xl mx-auto">
          <div className="grid md:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-4xl lg:text-5xl font-bold mb-6">About Me</h2>
              <p className="text-slate-400 text-lg leading-relaxed mb-6">
                <span className="text-white font-medium">With 7+ years of experience, I specialize in bridging the gap between design and development. I build responsive, user-friendly web applications that deliver seamless experiences across all devices.
                </span>
              </p>
              <p className="text-slate-400 text-lg leading-relaxed">
                My approach focuses on clean design, thoughtful micro-interactions, and scalable frontend architecture.
              </p>
            </div>
            <div className="relative group">
              <div className="absolute inset-0 bg-gradient-to-tr from-purple-500/20 to-blue-500/20 rounded-3xl blur-2xl transition-all duration-500 group-hover:bg-gradient-to-tr group-hover:from-purple-500/30 group-hover:to-blue-500/30" />
              <div className="relative bg-slate-900/50 backdrop-blur-xl border border-white/10 rounded-3xl p-8 shadow-2xl">
                <h3 className="text-xl font-semibold mb-6 flex items-center gap-2">
                  <svg className="w-6 h-6 text-purple-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
                  </svg>
                  Tech Stack
                </h3>
                <div className="flex flex-wrap gap-3">
                  {skills.map((skill, index) => (
                    <span key={index} className="px-4 py-2.5 bg-white/5 border border-white/10 rounded-xl text-sm font-medium text-slate-300 hover:bg-white/10 hover:border-white/20 hover:text-white transition-all duration-300 cursor-default">
                      {skill}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* PROJECTS SECTION */}
        <section id="projects" className="py-24 px-6 relative">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-20">
              <h2 className="text-4xl md:text-5xl font-bold mb-4">Featured Projects</h2>
              <p className="text-slate-400 text-lg">A curated selection of my recent UI/UX and frontend development projects.</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {projects.map((project, index) => (
                <a
                  key={index}
                  href={project.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group relative flex flex-col justify-between p-8 h-80 bg-slate-900/40 backdrop-blur-sm border border-white/10 rounded-3xl overflow-hidden transition-all duration-500 hover:-translate-y-3 hover:border-white/30 hover:shadow-[0_20px_40px_-20px_rgba(168,85,247,0.4)]"
                >
                  <div className="absolute inset-0 bg-gradient-to-br from-purple-500/0 via-transparent to-blue-500/0 group-hover:from-purple-500/10 group-hover:to-blue-500/10 transition-colors duration-500" />

                  <div className="relative z-10">
                    <div className="text-xs font-bold tracking-widest text-purple-400 uppercase mb-4">
                      {project.category}
                    </div>
                    <h3 className="text-2xl font-bold mb-4 group-hover:text-transparent group-hover:bg-clip-text group-hover:bg-gradient-to-r group-hover:from-white group-hover:to-slate-300 transition-all">
                      {project.title}
                    </h3>
                    <p className="text-slate-400 leading-relaxed line-clamp-3">
                      {project.description}
                    </p>
                  </div>

                  <div className="relative z-10 flex items-center font-semibold text-sm text-slate-300 group-hover:text-white transition-colors mt-4">
                    Visit Website
                    <svg className="w-4 h-4 ml-2 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                    </svg>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </section>

        {/* CONTACT SECTION */}
        <section id="contact" className="py-24 px-6 border-t border-white/5 bg-slate-900/20 relative z-10">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">Let's Build Something Beautiful</h2>
            <p className="text-xl text-slate-400 mb-12">
              I'm always open to discussing product design work or partnership opportunities.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
              <a href="mailto:seloteanisha@gmail.com" className="flex items-center gap-3 px-8 py-4 bg-white/5 border border-white/10 rounded-full hover:bg-white/10 hover:border-white/20 transition-all duration-300 w-full sm:w-auto justify-center">
                <svg className="w-5 h-5 text-slate-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                seloteanisha@gmail.com
              </a>
              <a href="tel:+919561509124" className="flex items-center gap-3 px-8 py-4 bg-white/5 border border-white/10 rounded-full hover:bg-white/10 hover:border-white/20 transition-all duration-300 w-full sm:w-auto justify-center">
                <svg className="w-5 h-5 text-slate-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                +91 9561509124
              </a>
            </div>

            <div className="mt-28 text-slate-500 text-sm">
              © {new Date().getFullYear()} Anisha. All rights reserved. Built with React.js and Tailwind CSS.
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default App;
